import React from "react";
import { API } from "../../lib/api";
import { Download } from "lucide-react";

const COLLECTIONS = [
  "businesses", "intake_sessions", "evidence", "constraints", "contradictions",
  "assets", "interventions", "blueprints", "projects", "care_plans",
  "follow_ups", "notes", "files", "status_history", "leave_alone",
];

export default function ExportData() {
  const token = localStorage.getItem("lr_token");
  const url = (c, fmt) => `${API}/export/${c}?format=${fmt}&auth=${token}`;

  const go = (c, fmt) => {
    // fetch with auth then download blob (query auth also works but header preferred)
    fetch(`${API}/export/${c}?format=${fmt}`, { credentials: "include", headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.download = `${c}.${fmt}`;
        a.click();
        URL.revokeObjectURL(a.href);
      });
  };

  return (
    <div className="p-5 md:p-8 max-w-4xl">
      <h1 className="font-serif text-3xl md:text-4xl text-lr-charcoal mb-2">Export data</h1>
      <p className="text-lr-leather mb-6">All core business data is yours. Download any collection as CSV or JSON.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {COLLECTIONS.map((c) => (
          <div key={c} className="lr-card p-4 flex items-center justify-between" data-testid={`export-${c}`}>
            <span className="text-lr-charcoal capitalize">{c.replace(/_/g, " ")}</span>
            <div className="flex gap-2">
              <button onClick={() => go(c, "csv")} data-testid={`export-${c}-csv`}
                className="text-sm px-3 py-1.5 rounded-[4px] border hairline text-lr-olive hover:bg-lr-olive/10 flex items-center gap-1">
                <Download className="h-3.5 w-3.5" /> CSV
              </button>
              <button onClick={() => go(c, "json")} data-testid={`export-${c}-json`}
                className="text-sm px-3 py-1.5 rounded-[4px] border hairline text-lr-olive hover:bg-lr-olive/10 flex items-center gap-1">
                <Download className="h-3.5 w-3.5" /> JSON
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
